export function formatLan(object) {
    var storageLan = window.localStorage.getItem('translate')
    switch (storageLan) {
        case "zh":
            return object['zh-CN']
        case "en":
            return object['en']
        case "zh-hk":
            return object['zh-HK']
        default:
            break;
    }
}

export function chooseStyle() {
    var storageLan = window.localStorage.getItem('translate')
    switch (storageLan) {
        case "en":
            return "ZCOOL";
        case "zh":
            return "ZCOOL";
        case "zh-hk":
            return "zh-HK";
    }
}